export type LoyaltyLevel = {
  level: number;
  cp: number;
  prizeValues?: LoyaltyLevelPrizeValues;
  prizeLabel: LoyaltyLevelPrizeLabel;
};

export type LoyaltyLevelPrizeValues = {
  amount?: number;
  multiplier?: number;
  bonusAmount?: number;
};

export enum LoyaltyLevelPrizeLabel {
  CP = 'loyalty:boostBlock.levelPrizeLabels.CP',
  CP_CASHOUT = 'loyalty:boostBlock.levelPrizeLabels.CP_CASHOUT',
  CP_BONUS_CASH = 'loyalty:boostBlock.levelPrizeLabels.CP_BONUS_CASH',
  LOOTBOX = 'loyalty:boostBlock.levelPrizeLabels.LOOTBOX',
  CASHOUT = 'loyalty:boostBlock.levelPrizeLabels.CASHOUT',
  SPINS = 'loyalty:boostBlock.levelPrizeLabels.SPINS',
  BONUS_CASH = 'loyalty:boostBlock.levelPrizeLabels.BONUS_CASH',
  BONUS_CASH_CASHOUT = 'loyalty:boostBlock.levelPrizeLabels.BONUS_CASH_CASHOUT',
}

export const loyaltyLevels: LoyaltyLevel[] = [
  {
    level: 1,
    cp: 50,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 10 },
  },
  {
    level: 2,
    cp: 100,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 15 },
  },
  {
    level: 3,
    cp: 350,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 25 },
  },
  {
    level: 4,
    cp: 750,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 5,
    cp: 1000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 25 },
  },
  {
    level: 6,
    cp: 2000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 50 },
  },
  {
    level: 7,
    cp: 3500,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH,
    prizeValues: { amount: 10 },
  },
  {
    level: 8,
    cp: 5000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 75 },
  },
  {
    level: 9,
    cp: 7500,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 10,
    cp: 10_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 100 },
  },
  {
    level: 11,
    cp: 15_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 100 },
  },
  {
    level: 12,
    cp: 20_000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH,
    prizeValues: { amount: 15 },
  },
  {
    level: 13,
    cp: 25_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 150 },
  },
  {
    level: 14,
    cp: 30_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CASHOUT,
    prizeValues: { multiplier: 2 },
  },
  {
    level: 15,
    cp: 35_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 15 },
  },
  {
    level: 16,
    cp: 40_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 200 },
  },
  {
    level: 17,
    cp: 45_000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH,
    prizeValues: { amount: 25 },
  },
  {
    level: 18,
    cp: 50_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 350 },
  },
  {
    level: 19,
    cp: 55_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 20,
    cp: 60_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 200 },
  },
  {
    level: 21,
    cp: 70_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 500 },
  },
  {
    level: 22,
    cp: 80_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CASHOUT,
    prizeValues: { multiplier: 2 },
  },
  {
    level: 23,
    cp: 90_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 750 },
  },
  {
    level: 24,
    cp: 100_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 25,
    cp: 110_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 250 },
  },
  {
    level: 26,
    cp: 120_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 1000 },
  },
  {
    level: 27,
    cp: 130_000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH,
    prizeValues: { amount: 35 },
  },
  {
    level: 28,
    cp: 140_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 1250 },
  },
  {
    level: 29,
    cp: 150_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 30,
    cp: 160_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 300 },
  },
  {
    level: 31,
    cp: 175_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 1500 },
  },
  {
    level: 32,
    cp: 190_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CASHOUT,
    prizeValues: { multiplier: 2 },
  },
  {
    level: 33,
    cp: 205_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 1750 },
  },
  {
    level: 34,
    cp: 220_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 35,
    cp: 235_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 350 },
  },
  {
    level: 36,
    cp: 250_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 2000 },
  },
  {
    level: 37,
    cp: 265_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 38,
    cp: 280_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_BONUS_CASH,
    prizeValues: { amount: 2500, bonusAmount: 50 },
  },
  {
    level: 39,
    cp: 295_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 40,
    cp: 310_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 400 },
  },
  {
    level: 41,
    cp: 330_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 3000 },
  },
  {
    level: 42,
    cp: 350_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 43,
    cp: 370_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_CASHOUT,
    prizeValues: { amount: 3500, multiplier: 2 },
  },
  {
    level: 44,
    cp: 390_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 45,
    cp: 410_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 450 },
  },
  {
    level: 46,
    cp: 430_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 4000 },
  },
  {
    level: 47,
    cp: 450_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 48,
    cp: 470_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_BONUS_CASH,
    prizeValues: { amount: 4500, bonusAmount: 75 },
  },
  {
    level: 49,
    cp: 490_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 50,
    cp: 510_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 500 },
  },
  {
    level: 51,
    cp: 540_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 5000 },
  },
  {
    level: 52,
    cp: 570_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 53,
    cp: 600_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CASHOUT,
    prizeValues: { amount: 5500, multiplier: 2 },
  },
  {
    level: 54,
    cp: 630_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 55,
    cp: 660_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 550 },
  },
  {
    level: 56,
    cp: 690_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 6000 },
  },
  {
    level: 57,
    cp: 720_000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH,
    prizeValues: { amount: 100 },
  },
  {
    level: 58,
    cp: 750_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_CASHOUT,
    prizeValues: { amount: 6500, multiplier: 2 },
  },
  {
    level: 59,
    cp: 780_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 60,
    cp: 810_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 600 },
  },
  {
    level: 61,
    cp: 850_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_CASHOUT,
    prizeValues: { amount: 7000, multiplier: 2 },
  },
  {
    level: 62,
    cp: 890_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 63,
    cp: 930_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 7500 },
  },
  {
    level: 64,
    cp: 970_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 65,
    cp: 1_010_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 650 },
  },
  {
    level: 66,
    cp: 1_050_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 8000 },
  },
  {
    level: 67,
    cp: 1_090_000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH_CASHOUT,
    prizeValues: { amount: 125, multiplier: 2 },
  },
  {
    level: 68,
    cp: 1_130_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 8500 },
  },
  {
    level: 69,
    cp: 1_170_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 70,
    cp: 1_210_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 700 },
  },
  {
    level: 71,
    cp: 1_260_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_CASHOUT,
    prizeValues: { amount: 9000, multiplier: 2 },
  },
  {
    level: 72,
    cp: 1_310_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 73,
    cp: 1_360_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 9500 },
  },
  {
    level: 74,
    cp: 1_410_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 75,
    cp: 1_460_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 750 },
  },
  {
    level: 76,
    cp: 1_510_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 10_000 },
  },
  {
    level: 77,
    cp: 1_560_000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH_CASHOUT,
    prizeValues: { amount: 150, multiplier: 2 },
  },
  {
    level: 78,
    cp: 1_610_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 12_500 },
  },
  {
    level: 79,
    cp: 1_660_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 80,
    cp: 1_710_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 800 },
  },
  {
    level: 81,
    cp: 1_760_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 15_000 },
  },
  {
    level: 82,
    cp: 1_810_000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH,
    prizeValues: { amount: 200 },
  },
  {
    level: 83,
    cp: 1_860_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_CASHOUT,
    prizeValues: { amount: 20_000, multiplier: 2 },
  },
  {
    level: 84,
    cp: 1_910_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 85,
    cp: 1_960_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 850 },
  },
  {
    level: 86,
    cp: 2_025_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP,
    prizeValues: { amount: 25_000 },
  },
  {
    level: 87,
    cp: 2_090_000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH,
    prizeValues: { amount: 250 },
  },
  {
    level: 88,
    cp: 2_155_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 89,
    cp: 2_220_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_CASHOUT,
    prizeValues: { amount: 30_000, multiplier: 2 },
  },
  {
    level: 90,
    cp: 2_285_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 900 },
  },
  {
    level: 91,
    cp: 2_360_000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH_CASHOUT,
    prizeValues: { amount: 300, multiplier: 2 },
  },
  {
    level: 92,
    cp: 2_435_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 93,
    cp: 2_510_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_CASHOUT,
    prizeValues: { amount: 35_000, multiplier: 2 },
  },
  {
    level: 94,
    cp: 2_585_000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH,
    prizeValues: { amount: 350 },
  },
  {
    level: 95,
    cp: 2_660_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 950 },
  },
  {
    level: 96,
    cp: 2_760_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_CASHOUT,
    prizeValues: { amount: 40_000, multiplier: 2 },
  },
  {
    level: 97,
    cp: 2_860_000,
    prizeLabel: LoyaltyLevelPrizeLabel.BONUS_CASH_CASHOUT,
    prizeValues: { amount: 400, multiplier: 2 },
  },
  {
    level: 98,
    cp: 2_960_000,
    prizeLabel: LoyaltyLevelPrizeLabel.LOOTBOX,
  },
  {
    level: 99,
    cp: 3_060_000,
    prizeLabel: LoyaltyLevelPrizeLabel.CP_CASHOUT,
    prizeValues: { amount: 45_000, multiplier: 2 },
  },
  {
    level: 100,
    cp: 3_160_000,
    prizeLabel: LoyaltyLevelPrizeLabel.SPINS,
    prizeValues: { amount: 1000 },
  },
];
